import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import MaterialBox from "../../../components/MaterialBox"
import MaterialInput from "../../../components/MaterialInput"
import { useBankFormHandling } from "./components/BankStateHandle"
import MaterialButton from "../../../components/MaterialButton"
import { fetchDataById, postData, putData } from "../../../services"
import { useEffect } from "react"
import { setCircleLoading } from "../../../components/Loading"
import { useSnackbar } from "../../../context/popup"

const BankNameForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const bankNameId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view"
    ? "view"
    : pageType === "edit"
    ? "edit"
    : pageType === "add"
    ? "add"
    : "add";
    const { formData,setFormData, handleChange, checkAllFields } = useBankFormHandling();

    useEffect(() => {
        if (pageMode === "add" || !bankNameId) {
            return;
        }

        //Fetch data by Pincode Id
        const fetchBankById = async (bankNameId) => {
            try {
            const response = await fetchDataById(`/reference/general/bank/${bankNameId}`);

            const responseData = response?.data;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    iplBankId: responseData?.id || "",
                    active: responseData?.isActive,
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    iplBankIdStatus: responseData?.id ? "success" : "unchecked",

                };

                setFormData(mapped);   //view data
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar(error?.response?.data?.message || "Error fetching data by ID", "error");
            }
        };

        fetchBankById(bankNameId);
    }, [pageMode]);

    const handleAddBank = async () => {
        setCircleLoading(true);
        try {
            if(pageMode === "edit"){
                const bankNamePutData = {
                    name: formData?.name,          
                    isActive: formData.active
                }
                const response = await putData(`/reference/general/bank/${bankNameId}`, bankNamePutData);
                const successResponse = response?.success;
                const responseMessage = response?.message;
                if(successResponse){
                    navigate("/general-master/bank-list");
                    showSnackbar(responseMessage,"success");
                }
                else{
                    showSnackbar(responseMessage,"error");
                }
            }
            else if(pageMode === "add"){
                const bankNamePostData = {
                    name: formData?.name,          
                    isActive: formData.active
                }
                const response = await postData("/reference/general/bank", bankNamePostData);
    
                if (response?.success) {
                    showSnackbar(response?.message,"success");
                    setTimeout(() => {
                        navigate("/general-master/bank-list");
                    }, 1000);
                }
            }

        } catch (error) {
            console.error("Error Adding data:", error);
            showSnackbar(error?.response?.data?.message || "Error Adding Data", "error"); 
        }finally{
            setCircleLoading(false);
        }
    }

  return (
    <DashboardLayout>
        <CardHeader
        title={(
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={() => navigate("/general-master/bank-list")}>
                    <ArrowBack />
                    </IconButton>
                    <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Bank Name Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        Enter New Bank Details from around the world.
                    </MaterialTypography>
                    </Stack>
                </Stack>
            </Stack>
        )}
        />
        <CardContent>
            <Grid2 container spacing={2}>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            Bank Name
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                    name="name"
                    placeholder="eg. HDFC Bank"
                    value={formData.name}
                    onChange={handleChange}
                    success={formData.nameStatus === "success"}
                    error={formData.nameStatus === "error"}
                    disabled={pageMode === "view"}
                    />
                    {formData.nameStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                            Bank Name should be a minimum 1 character & maximum 80 characters long.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
                {(pageMode === "view" || pageMode === "edit") && (
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            Bank ID
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                    name="iplBankId"
                    value={formData.iplBankId}
                    onChange={handleChange}
                    success={formData.iplBankIdStatus === "success"}
                    error={formData.iplBankIdStatus === "error"}
                    disabled
                    />
                </Grid2>
                )}
                <Grid2 size={{lg:2, md:2, sm: 2, xs: 2 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            Active
                        </MaterialTypography>
                    </MaterialBox>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={formData.active}
                            disabled={pageMode === "view"}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "active",
                                        value: e.target.checked,
                                    },
                                })
                            }
                            color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {formData?.active ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2> 
            </Grid2>
        </CardContent>
        <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
        >
        {pageMode === "add" && (
        <>
            <MaterialButton
            sx={{ m: 2 }}
            variant="outlined"
            color="dark"
            onClick={() => navigate("/general-master/bank-list")}
            >
            Cancel
            </MaterialButton>
            <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleAddBank}
            >
            Submit
            </MaterialButton>
        </>
        )}

        {pageMode==="edit" && (
        <>
            <MaterialButton
            variant="outlined"
            color="dark"
            sx={{ m: 2 }}
            onClick={() => navigate("/general-master/bank-list")}
            >
            Cancel
            </MaterialButton>
            <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleAddBank}
            >
            Update
            </MaterialButton>
        </>
        )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default BankNameForm